
import { defineComponent, PropType } from "vue";
import GameButton from "@/components/GameButton.vue";
import { GameColor } from "@/data/types";

export default defineComponent({
  name: "ActionButton",

  components: {
    GameButton,
  },

  data() {
    return {
      flyOuts: [] as { key: number; value: string }[],
      lastLabel: "",
      flyOutTimeout: 0,
    };
  },

  props: {
    label: {
      type: String,
    },
    alternative: {
      type: String,
      default: "",
    },
    isLarge: {
      type: Boolean,
    },
    isBorderless: {
      type: Boolean,
    },
    hasFlyOut: {
      type: Boolean,
    },
    actionCounter: {
      type: Number,
      default: 0,
    },
    backgroundColor: {
      type: String as PropType<GameColor>,
      default: "",
    },
  },

  computed: {
    colorClass() {
      return {
        "background--red": this.backgroundColor === "red",
        "background--green": this.backgroundColor === "green",
        "background--blue": this.backgroundColor === "blue",
        "background--yellow": this.backgroundColor === "yellow",
      };
    },
    flyOutClass() {
      return {
        "action-button__flyout--large":
          this.isLarge && this.alternative.length <= 2,
        "action-button__flyout--large-small-alt":
          this.isLarge && this.alternative.length > 2,
      };
    },
  },

  methods: {
    handleClick() {
      console.log(this.label);
    },
  },

  watch: {
    label(newVal, oldVal) {
      if (oldVal) this.lastLabel = oldVal;
    },
    actionCounter(newVal) {
      this.flyOuts.push({
        key: newVal,
        value: this.lastLabel,
      });
      if (this.flyOuts.length > 10) {
        this.flyOuts = this.flyOuts.slice(-10);
      }
    },
  },
});
